// The one door to the server for pages and components: typed functions in
// src/services/*.ts, built on these four verbs. They return the response
// BODY (not the axios envelope) — a caller writes `const dj = await
// usersApi.get(slug)`, never `res.data`. Transport concerns (bearer token,
// CSRF, refresh-on-401) stay in src/api.ts, untouched.
//
// Errors are axios errors as before: `err.response?.status`,
// `err.response?.data?.msg` still work at every call site.
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import api from "../api";

export const http = {
  get: <T>(url: string, config?: AxiosRequestConfig): Promise<T> => api.get<T>(url, config).then((r) => r.data),
  /** The whole response (status and headers), for the rare read that needs them: the Spotlight feed's ETag and 304. */
  getRaw: <T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => api.get<T>(url, config),
  post: <T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<T> =>
    api.post<T>(url, body, config).then((r) => r.data),
  patch: <T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<T> =>
    api.patch<T>(url, body, config).then((r) => r.data),
  put: <T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<T> =>
    api.put<T>(url, body, config).then((r) => r.data),
  delete: <T>(url: string, config?: AxiosRequestConfig): Promise<T> => api.delete<T>(url, config).then((r) => r.data),
};
